import request from '@/utils/request'
export function getScheduling(data) {
    return request({
        url: '/api/SchedulingModule/Scheduling/GetListAsyncByFilterOnlyMe',
        method: 'get',
        params: {
            BeginTime: data.BeginTime,
            EndTime: data.EndTime,
            NeedCurrentUser: false,
            IsSameOrgin:false,
            createType:data.createType,
            TempleIdList:data.templelist,
            UserName:data.username,
        }
    })
}

export function updateJournal(msg, id) {
    return request({
        headers:{
            'content-type':'application/json-patch+json'
        },
        url: '/api/SchedulingModule/Scheduling/UpdateJournal',
        method: 'post',
        params: {
            id: id
        },
        data: JSON.stringify(msg)
    })
}

export function getapiticket(params){
    return request({
        method:'get',
        url:'/api/schedulingmodule/scheduling/sign',
        params:params
    })
}

export function GetAddressListAsync(input) {
    return request({
      url: '/api/schedulingModule/ShapeApp/AddressList',
      method: 'get',
      params: input
    })
  }

export function GetUserInRuleList(){
    return request({
        url:'/api/schedulingmodule/scheduling/getuserinrulelist?createType=1',
        method:'get'
    })
}

export function getTempleList(createType){
    return request({
        url:'/api/SchedulingModule/Temple',
        method:'get',
        params:{
            createType:createType,
            IsCurrentUser:false,
            SkipCount:0,
            MaxResultCount:1000
        }
    })
}

// export function register(){
//     return request({
//         baseURL:'http://172.18.88.132:9999',
//         url:'api/account/register',
//         method:'post',
//         data:{
//             userName: "1234567",
//             emailAddress: "user7@example.com",
//             password: "1q2w3E*",
//             appName: "zt"
//         }
//     })
// }

export function GetPageAsync(data){
    return request({
        url:'/api/SchedulingModule/Scheduling/GetPageAsync',
        method:'get',
        params:{
            IsCurrentUser:true,
            BeginTime:data.beginTime,
            EndTime:data.endTime,
            SkipCount:data.skipcount,
            createTypes:data.createTypes,
            createtype:data.createType
        }
    })
}

export function GetRoleUser(roleName){
    return request({
        url:'/api/identity/users/GetListByNormalizedRoleNameAsync',
        method:'get',
        params:{
            roleName:roleName
        }
    })
}

export function GetOnlyName(data){
    return request({
        url:'/api/SchedulingModule/Scheduling/OnlyName',
        method:'get',
        params:{
           createType:data.createType,
        }
    })
}


export function getId(_id) {
  return request({
    url: `/api/schedulingModule/scheduling/${_id}`,
    method: 'get'
  })
}



export function Updateform(data, _id) {
  return request({
    url: `/api/schedulingModule/scheduling/${_id}`,
    method: 'put',
    data: data
  })
}


export function delform(_id) {
  return request({
    url: `/api/schedulingModule/scheduling/${_id}`,
    method: 'delete'
  })
}


export function AddScheduling(data) {
  return request({
    url: '/api/schedulingModule/scheduling',
    method: 'post',
    data: data
  })
}